var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9 18H17.1C17.3387 18 17.5676 17.9052 17.7364 17.7364C17.9052 17.5676 18 17.3387 18 17.1V0.9C18 0.661305 17.9052 0.432387 17.7364 0.263604C17.5676 0.0948211 17.3387 0 17.1 0H0.9C0.661305 0 0.432387 0.0948211 0.263604 0.263604C0.0948211 0.432387 0 0.661305 0 0.9V17.1C0 17.3387 0.0948211 17.5676 0.263604 17.7364C0.432387 17.9052 0.661305 18 0.9 18ZM3.0726 16.2L7.2 12.0726L8.3637 13.2363C8.53248 13.405 8.76135 13.4998 9 13.4998C9.23865 13.4998 9.46752 13.405 9.6363 13.2363L13.5 9.3726L16.2 12.0726V16.2H3.0726ZM16.2 1.8V9.5274L14.1363 7.4637C13.9675 7.29498 13.7386 7.20019 13.5 7.20019C13.2614 7.20019 13.0325 7.29498 12.8637 7.4637L9 11.3274L7.8363 10.1637C7.66752 9.99498 7.43865 9.90019 7.2 9.90019C6.96135 9.90019 6.73247 9.99498 6.5637 10.1637L1.8 14.9274V1.8H16.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIconWhite);
export default __webpack_public_path__ + "static/media/img-icon-white.d926d8ce7fdae66710e5cfd2b12d0d31.svg";
export { ForwardRef as ReactComponent };